module.exports = __webpack_public_path__ + "static/media/work2.0e87063c.jpg";